module.exports = __webpack_public_path__ + "img/audio.1a14ee82.png";